import store from '../store'
export default {
  collectionPath (collectionKey) {
    let collection = store.state.Collection.collections[collectionKey]
    let pathTokens = []
    if (collection.type !== 'system') pathTokens.push('collections')
    pathTokens.push(collectionKey)
    return `/${pathTokens.join('/')}`
  },
  collectionRecipePath (collectionKey, recipeKey) {
    let collection = store.state.Collection.collections[collectionKey]
    let pathTokens = []
    if (collection.type !== 'system') pathTokens.push('collections')
    pathTokens.push(collectionKey)
    pathTokens.push(...['recipes', recipeKey])
    return `/${pathTokens.join('/')}`
  },
  searchRecipePath (query, recipeKey) {
    let pathTokens = ['search', query, 'recipes', recipeKey].filter(q => Boolean(q))
    return `/${pathTokens.join('/')}`
  }
}



// WEBPACK FOOTER //
// ./src/router/urlHelpers.js